'use client';

import React, { useEffect, useState } from 'react';
import { ClipboardMinus, Printer, Trash2, File, SearchIcon } from 'lucide-react';
import { Card, Button, Table, Label, Input } from 'reactstrap';
import { Tooltip } from "react-tooltip";
import { useNavigate } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import InvoiceReceipt from './InvoiceReceipt';
import { useTranslation } from 'react-i18next';
import { cancelTestOrder, getTestOrder } from './service/report-test-service';
import { useLoader } from '../../_helper/LoaderContext';
import MyPagination from '../pagination';
import { useCurrency } from "../../_helper/currencyContext";
import { useLab } from "../../_helper/PharmacyProvider";
import ReportList from './ReportList';
import Payment from '../ladger/Payment';
import { getInvoiceDetail } from '../ladger/service/ledger-service';
import { toast } from 'react-toastify';
import { FormLabel } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { masterDoctor } from '../SearchPatient/services/search-patient';

export default function TestHome() {
    const { t } = useTranslation()
    const [show, setShow] = useState(false);
    const [showResult, setShowResult] = useState(false);
    const handleClose = () => setShow(false);
    const handleCloseResult = () => setShowResult(false);
    const [customerType, setCustomerType] = useState('all');
    const [patients, setPatients] = useState([]);
    const navigate = useNavigate();
    const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [reportStatus, setReportStatus] = useState("");
    const [paymentStatus, setPaymentStatus] = useState("");
    const [entriesPerPage, setEntriesPerPage] = useState(10);
    const [totalEntries, setTotalEntries] = useState(0);
    const { setLoading } = useLoader();
    const [showTests, setShowTests] = useState(null);
    const { getCurrencySymbol } = useCurrency();
    const { currentLab } = useLab();
    const [data, setData] = useState({})
    const [trData, setTrData] = useState({})
    const [doctor, setDoctor] = useState([])
    const [selectedDoctor, setSelectedDoctor] = useState("");
    useEffect(() => {
        getList()
    }, [currentPage, entriesPerPage, search, totalEntries, reportStatus, paymentStatus, selectedDoctor])

    const getList = async () => {
        setLoading(true)
        try {
            const form_data = new FormData()
            form_data.append("search", search);
            form_data.append("page", currentPage);
            form_data.append("limit", entriesPerPage);
            form_data.append("doctorName", selectedDoctor);
            if (reportStatus) {
                form_data.append("status", reportStatus);
            }
            if (paymentStatus === "paid") {
                form_data.append("isPaid", true);
            }
            else if (paymentStatus === "partial") {
                form_data.append("isPartialPaid", true);
            }
            const res = await getTestOrder(form_data)
            // console.log(res)
            if (res.data.success == true) {
                setPatients(res.data.data.testOrders)
                setTotalEntries(res.data.data.pagination.totalItems || 0);
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        getMasterDoctor()
    }, [])

    const getMasterDoctor = async () => {
        setLoading(true);
        try {
            const res = await masterDoctor();
            if (res.data.success) setDoctor(res.data.data);
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };


    const totalPages = Math.ceil(totalEntries / entriesPerPage);

    const openModel = async (data) => {
        // console.log(data)
        setLoading(true)
        try {
            const res = await getInvoiceDetail(data._id);
            if (res.data.success == true) {
                setTrData(res.data.data)
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
        setShow(true)
    }

    const openResult = (row) => {
        setData(row)
        setShowResult(true)
    }

    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            getList();
        }, 500); // waits 0.5s after typing stops

        return () => clearTimeout(delayDebounce);
    }, [search, currentPage, entriesPerPage]);

    const cancelOrder = async (data) => {

        Swal.fire({
            title: "Are you sure?",
            text: `You want to cancel this test? ${getCurrencySymbol(data.payment?.currency)}${Number(data.payment.paid).toFixed(2)} amount will be refund`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: `Yes, Cancel it!`
        }).then(async (result) => {
            if (result.isConfirmed) {
                setLoading(true)
                try {
                    const res = await cancelTestOrder(data._id)
                    if (res.data.success == true) {
                        toast.success(res.data.message);
                        getList()
                    }
                } catch (error) {
                    console.log(error);
                } finally {
                    setLoading(false)
                }
            }
        });

    }

    const handlePageSizeChange = (e) => {
        const newSize = Number(e.target.value);
        setEntriesPerPage(newSize);  // Use the correct setter
        setCurrentPage(1);           // Reset to page 1
    }

    const getStartingSerialNumber = () => {
        return (currentPage - 1) * entriesPerPage + 1;
    };

    return (
        <>
            <Card>
                <div className="p-3 mt-4">
                    <div className="tw-max-w-full tw-mx-auto">
                        <div className="row mb-4 align-items-center">
                            <div className="col-md-6">
                                <div className="input-group">
                                    <span className="input-group-text tw-bg-white" id="basic-addon1"><SearchIcon /></span>
                                    <input type="text" className="form-control icon_form" placeholder="Search By Patient Name..." aria-label="Username" aria-describedby="basic-addon1" style={{ borderLeft: 'none' }} value={search} onChange={(e) => setSearch(e.target.value)} />
                                </div>
                            </div>

                            <div className="col-md-3">
                                <select className="form-select" placeholder="Select Report Status" value={reportStatus}
                                    onChange={(e) => {
                                        setReportStatus(e.target.value);
                                        setCurrentPage(1);
                                    }}>
                                    <option value="">Report Status</option>
                                    <option value="Partial">Inprogress</option>
                                    <option value="Ordered">Ordered</option>
                                    <option value="Completed">Completed</option>
                                    <option value="cancelled">Cancelled</option>
                                    <option value="Submitted">Submitted</option>
                                </select>
                            </div>
                            <div className="col-md-3">
                                <select className="form-select" value={selectedDoctor} onChange={(e) => {
                                    setSelectedDoctor(e.target.value)

                                }}>
                                    <option value="">Select Doctor</option>
                                    {doctor.map(d => <option key={d._id} value={`${d.fname} ${d.lname}`}>{d.fname} {d.lname}</option>)}
                                </select>
                            </div>
                        </div>
                        <div className="recent-table table-responsive currency-table tw-rounded-lg tw-border tw-border-black"
                        >
                            <Table className="mb-0 table-center table-bordered table-hover" style={{ overflowX: "auto", tableLayout: 'fixed' }}>
                                <thead>
                                    <tr>
                                        <th className="text-center bg-primary tw-text-center" style={{
                                            width: "80px"
                                        }}>
                                            <b>#</b>
                                        </th>
                                        <th className="bg-primary text-white text-left tw-sticky tw-left-0 z-30" style={{ width: '160px' }}><b>Patient Name</b></th>
                                        <th className="bg-primary text-white text-left" style={{ width: '200px' }}><b>Rf. Doctor</b></th>
                                        <th className="bg-primary text-white text-left" style={{ width: '160px' }}><b>Lab User</b></th>
                                        <th className="bg-primary text-white text-left" style={{ width: '150px' }}><b>Tests</b></th>
                                        <th className="bg-primary text-white text-center" style={{ width: '130px' }}><b>Taxable Amt</b></th>
                                        <th className="bg-primary text-white text-center" style={{ width: '130px' }}><b>Discount (%)</b></th>
                                        <th className="bg-primary text-white text-center" style={{ width: '140px' }}><b>Discount Amt</b></th>
                                        <th className="bg-primary text-white text-center" style={{ width: '130px' }}><b>Tax %</b></th>
                                        <th className="bg-primary text-white text-center" style={{ width: '130px' }}><b>IGST Amt</b></th>
                                        <th className="bg-primary text-white text-center" style={{ width: '130px' }}><b>Total Amt</b></th>
                                        <th className="bg-primary text-white text-center" style={{ width: '130px' }}><b>Paid</b></th>
                                        <th className="bg-primary text-white text-center" style={{ width: '150px' }}><b>Date</b></th>
                                        <th className="bg-primary text-white text-center" style={{ width: '150px' }}><b>Report</b></th>
                                        <th className="bg-primary text-white text-center" style={{ width: '130px' }}><b>Action</b></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {patients.length > 0 ? (
                                        patients.map((patient, index) => {
                                            const serialNumber = getStartingSerialNumber() + index;
                                            return (
                                                <tr key={patient._id} className={index % 2 === 0 ? '' : ''}>

                                                    <td className="text-center font-weight-bold">
                                                        {serialNumber}
                                                    </td>
                                                    {/* Patient Name */}
                                                    <td className=" tw-py-3 tw-sticky tw-left-0 z-30">
                                                        <div
                                                            className="tw-font-medium" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                                                            data-tooltip-id={`cname-tooltip-${patient.patient.name}`}
                                                            data-tooltip-content={patient.patient.name}
                                                        >
                                                            {patient.patient.name}
                                                        </div>
                                                        <Tooltip id={`cname-tooltip-${patient.patient.name}`} place="top" />
                                                    </td>

                                                    {/* Doctor */}
                                                    <td className="tw-px-3 tw-py-3" >
                                                        <div className="tw-font-medium" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                            <span
                                                                data-tooltip-id="doctor-tooltip"
                                                                data-tooltip-content={patient.doctor?.name}
                                                            >
                                                                {patient.doctor?.name || "--- --- ---"}
                                                            </span>
                                                            <Tooltip id="doctor-tooltip" place="top" />

                                                        </div>
                                                    </td>

                                                    {/* Lab user */}
                                                    <td className="tw-py-3">
                                                        <div
                                                            className="tw-font-medium" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                                                            data-tooltip-id={`cname-tooltip-${patient.createdBy.name}`}
                                                            data-tooltip-content={patient.createdBy.name}
                                                        >
                                                            {patient.createdBy.name || "--- --- ---"}
                                                        </div>
                                                        <Tooltip id={`cname-tooltip-${patient.createdBy.name}`} place="top" />
                                                    </td>
                                                    {/* Tests */}
                                                    <td className="tw-px-3 tw-py-3">
                                                        <div className="tw-flex tw-items-center tw-gap-2">
                                                            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block' }}>
                                                                {patient.allTests[0].name}
                                                            </span>
                                                            {patient.allTests.length > 1 && (
                                                                <span
                                                                    className="tw-text-blue-600 tw-underline tw-cursor-pointer tw-shrink-0"
                                                                    onClick={() => setShowTests(patient._id)}
                                                                >
                                                                    +{patient.allTests.length - 1}
                                                                </span>
                                                            )}
                                                        </div>

                                                        {/* Modal for more tests */}
                                                        {showTests === patient._id && (
                                                            <div className="tw-fixed tw-inset-0 tw-bg-black/40 tw-z-50 tw-flex tw-items-center tw-justify-center" onClick={() => setShowTests(null)}>
                                                                <div className="tw-bg-white tw-rounded-lg tw-p-6 tw-max-w-md tw-w-full tw-shadow-2xl" onClick={e => e.stopPropagation()}>

                                                                    <ul className="tw-space-y-2 tw-max-h-96 tw-overflow-y-auto">
                                                                        {patient.allTests.map((t, i) => (
                                                                            <li key={i} className="tw-py-2 tw-px-3 tw-bg-gray-50 tw-rounded" style={{ color: 'black' }}>
                                                                                {t.name}
                                                                            </li>
                                                                        ))}
                                                                    </ul>
                                                                    <button
                                                                        className="tw-mt-4 tw-w-full btn btn-secondary"
                                                                        onClick={() => setShowTests(null)}
                                                                    >
                                                                        Close
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </td>



                                                    {/* Taxable Total */}
                                                    <td className="tw-px-3 tw-py-3 text-center">
                                                        <span className="tw-font-bold text-success">
                                                            {getCurrencySymbol(patient.payment?.currency)}{Number(patient.payment.totalPrice).toFixed(2)}
                                                        </span>
                                                    </td>
                                                    {/* Discount % */}
                                                    <td className="tw-px-3 tw-py-3 text-center">
                                                        <span className="tw-font-bold">
                                                            {patient.payment.discount.percentage > 0 ? (
                                                                <div className="">
                                                                    {patient.payment.discount.percentage}%
                                                                </div>
                                                            ) : (
                                                                <div className=""> - </div>
                                                            )}
                                                        </span>
                                                    </td>
                                                    {/* Discount Amount */}
                                                    <td className="tw-px-3 tw-py-3 text-center">
                                                        <span className="tw-font-bold ">
                                                            {patient.payment.discount.amount > 0.0 ? (
                                                                <div className="">
                                                                    {getCurrencySymbol(patient.payment?.currency)}{Number(patient.payment.discount.amount).toFixed(2)}
                                                                </div>
                                                            ) : (
                                                                <div className=""> - </div>
                                                            )}
                                                        </span>
                                                    </td>

                                                    {/* Tax % */}
                                                    <td className="tw-px-3 tw-py-3 text-center">
                                                        <span className="tw-font-bold text-success">
                                                            {Number(patient.payment.IGSTPercentage)}%
                                                        </span>
                                                    </td>

                                                    {/* IGST Amount */}
                                                    <td className="tw-px-3 tw-py-3 text-center">
                                                        <span className="tw-font-bold text-success">
                                                            {getCurrencySymbol(patient.payment?.currency)}{Number(patient.payment.IGST).toFixed(2)}
                                                        </span>
                                                    </td>

                                                    {/* Total Amount */}
                                                    <td className="tw-px-3 tw-py-3 text-center">
                                                        <span className="tw-font-bold text-success">
                                                            {getCurrencySymbol(patient.payment?.currency)}{Number(patient.payment.netTotal).toFixed(2)}
                                                        </span>
                                                    </td>

                                                    {/* Paid */}
                                                    <td className="tw-px-3 tw-py-3 text-center">
                                                        <span className="tw-font-bold">
                                                            {getCurrencySymbol(patient.payment?.currency)}{Number(patient.payment.paid).toFixed(2)}
                                                        </span>
                                                    </td>

                                                    {/* Date */}
                                                    <td className="tw-px-3 tw-py-3 text-center tw-text-sm">
                                                        {new Date(patient.createdAt).toLocaleDateString("en-GB", {
                                                            day: "numeric",
                                                            month: "short",
                                                            year: "numeric"
                                                        }).replace(/ /g, " ")}
                                                    </td>

                                                    {/* Report Status */}
                                                    <td className="tw-px-3 tw-py-3 text-center">
                                                        {patient.status === "Completed" ? (
                                                            <span className="tw-font-bold tw-text-green-700">Completed</span>
                                                        ) : patient.status === "cancelled" ? (
                                                            <span className="tw-font-bold tw-text-red-700">Cancelled</span>
                                                        ) : patient.status === "Ordered" ? (
                                                            <span className="tw-font-bold tw-text-purple-700">Ordered</span>
                                                        ) : patient.status === "Submitted" ? (
                                                            <span className="tw-font-bold tw-text-green-800">Submitted</span>
                                                        ) : (
                                                            <span className="tw-font-bold tw-text-blue-700">Inprogress</span>
                                                        )}
                                                    </td>

                                                    {/* Actions */}
                                                    <td className="tw-px-4 tw-py-4">
                                                        <div className="tw-flex tw-items-center">
                                                            {patient.status !== "cancelled" && (
                                                                patient.status !== "Completed" ? (
                                                                    <>
                                                                        <Tooltip id="fileTip" place="top" content="Add Test Result" />
                                                                        <button className='success-action-mutted me-1' data-tooltip-id="fileTip" onClick={() => navigate(`${process.env.PUBLIC_URL}/Add-test_result/${patient._id}`)}>
                                                                            <i className="bi bi-journal-arrow-up" style={{ fontSize: "18px" }}></i>
                                                                        </button>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <Tooltip id="pdf" place="top" content="View Test Result" />
                                                                        <button className='success-action-button me-1' data-tooltip-id="pdf" onClick={() => openResult(patient)}>
                                                                            <i className="bi bi-journal-arrow-down" style={{ fontSize: "18px" }}></i>
                                                                        </button></>
                                                                )
                                                            )}

                                                            <Tooltip id="invoice" place="top" content="View Invoice" />
                                                            <button className='success-action-button me-1' data-tooltip-id="invoice" onClick={() => openModel(patient)} >
                                                                <i className="bi bi-receipt" style={{ fontSize: "18px" }}></i>
                                                            </button>

                                                            {patient.status !== "Completed" && patient.status !== "cancelled" && (
                                                                <>
                                                                    <Tooltip id="cancel" place="top" content="Cancel Test Order" />
                                                                    <button className='danger-action-button me-1' data-tooltip-id="cancel" onClick={() => cancelOrder(patient)} >
                                                                        <i className="bi bi-x-octagon-fill" style={{ fontSize: "18px" }}></i>
                                                                    </button>
                                                                </>
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                        )
                                    ) : (
                                        <tr>
                                            <td
                                                colSpan={11}
                                                className="text-center py-4 text-muted"
                                            >
                                                No data available
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                        <div className="d-md-flex align-items-center text-center justify-content-between mt-3 mb-3">
                            <div className="show-entries">
                                <FormLabel>Show&nbsp;</FormLabel>
                                <select style={{ display: 'unset', width: 'auto', padding: '0.375rem 2.25rem 0.375rem 0.75rem' }} value={entriesPerPage}
                                    onChange={handlePageSizeChange} className="form-control">
                                    <option value={5}>5</option>
                                    <option value={10}>10</option>
                                    <option value={30}>30</option>
                                    <option value={20}>20</option>
                                    <option value={50}>50</option>
                                </select>&nbsp;
                                <FormLabel>entries</FormLabel>
                            </div>
                            <MyPagination totalPages={totalPages} currentPage={currentPage} onPageChange={(page) => setCurrentPage(page)} />
                        </div>
                        {/* <div className="mt-3">

                            <MyPagination totalPages={totalPages}
                                currentPage={currentPage}
                                onPageChange={(page) => setCurrentPage(page)}></MyPagination>
                        </div> */}
                    </div>
                </div>
            </Card>
            {/* <Modal show={show} onHide={handleClose}> */}
            <Payment show={show} onHide={handleClose} trData={trData} />
            {/* <InvoiceReceipt setUploadModelOpen={handleClose} toggleUploadModel={handleClose} /> */}
            {/* </Modal> */}
            <Modal show={showResult} onHide={handleCloseResult} centered scrollable>
                <ReportList setUploadModelOpen={handleCloseResult} toggleUploadModel={handleCloseResult} data={data} />
            </Modal>

        </>
    );
}